import React, { useCallback, useState } from "react";
import { Breadcrumb, Tabs, Timeline } from "antd";
import {
  ActiveDotIcon,
  InactiveDotIcon,
  BackIcon,
  NoImageLogo,
} from "../../../../asset";
import { CloseIcon } from "../../../../asset";
import { t } from "i18next";
import style from "./vehiclePage.module.css";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import { useLocation, useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { useVehicle } from "./VehiclePage.hooks";
import { useEffect } from "react";
import moment from "moment";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";

export default function VehicleDetail() {
  const [userManagementOpen, setUserManagementOpen] = useState(false);

  const { state } = useLocation();

  const {
    vehicleDetail,
    doGetDetailVehicle,
    isDetailLoaded,
    setSelectedId,
    setSelectedUpdatedAt,
    setSelectedVehicleType,
    setSelectedVehicleNo,
    setDeleteConfirmationModalOpen,
    deleteConfirmationModalOpen,
    selectedId,
    selectedUpdatedAt,
    selectedVehicleType,
    selectedVehicleNo,
    successModalOpen,
    doDeleteVehicle,
    toVehicleList,
    doGetManagementHistoryList,
    managementHistoryList,
    convertTimestamp,
    convertToTime,
  } = useVehicle();

  const navigate = useNavigate();

  useEffect(() => {
    doGetDetailVehicle(state.id);
    doGetManagementHistoryList(state.id);
  }, []);

  const toEdit = useCallback(() => {
    navigate(ROUTES.VEHICLE.EDIT, {
      state: {
        id: state?.id,
        depot_id: vehicleDetail?.depot_id,
      },
    });
  }, [navigate, state?.id, vehicleDetail?.depot_id]);

  function deleteData(id, updated_at, vehicle_no, vehicle_type) {
    setSelectedId(id);
    setSelectedUpdatedAt(updated_at);
    setSelectedVehicleType(vehicle_type);
    setSelectedVehicleNo(vehicle_no);
    // doDeleteVehicle(id, updated_at)
    setDeleteConfirmationModalOpen(true);
  }

  return (
    <div>
      <DeleteConfirmationModal
        isOpen={deleteConfirmationModalOpen}
        onOk={() => setDeleteConfirmationModalOpen(false)}
        onCancel={() => doDeleteVehicle(selectedId, selectedUpdatedAt)}
        closable={false}
        width={440}
        className={style.modalContainer}
        okText="Cancel"
        cancelText="Yes, Delete"
        title="Delete Data?"
        description={
          <p>
            Are you sure want to delete <br />{" "}
            <strong>
              {selectedId} - {selectedVehicleType} -{" "}
              {selectedVehicleNo?.replaceAll("-", " ")}?
            </strong>
          </p>
        }
      />

      <SuccessModal
        isOpen={successModalOpen}
        onOk={() => toVehicleList()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Well Done"
        description="Your data has been deleted"
      />

      {isDetailLoaded ? (
        <div className="p-[24px] flex flex-col gap-[24px]">
          <Breadcumbs
            jmlLevel={4}
            menuLevel1={`Master`}
            menuLevel2={`Fleet`}
            menuLevel3={`Vehicle`}
            menuLevel4={`Detail ${vehicleDetail.vehicle_id} - ${
              vehicleDetail.vehicle_type
            } - ${vehicleDetail.vehicle_no.replaceAll("-", " ")}`}
          />

          <div className="flex items-center justify-between">
            <div
              className="flex items-center gap-[22px] cursor-pointer"
              onClick={() => toVehicleList()}
            >
              <img src={BackIcon} alt="" />
              <h1 className="font-sans-bold text-2xl" id="title">{`${t(
                "VEHICLE_DETAIL:TITLE"
              )} ${vehicleDetail.vehicle_id} - ${
                vehicleDetail.vehicle_type
              } - ${vehicleDetail.vehicle_no.replaceAll("-", " ")}`}</h1>
            </div>

            <div
              className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
              onClick={() => setUserManagementOpen(true)}
            >
              <p className="text-[#666666]">
                {t("USER_DETAIL:CREATED_BY")}{" "}
                <strong>{vehicleDetail.created_by_name}</strong>{" "}
                {t("USER_DETAIL:ON")}{" "}
                <strong>
                  {convertTimestamp(vehicleDetail.created_at, true)}
                </strong>{" "}
                | {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
                <strong>{vehicleDetail.updated_by_name}</strong>{" "}
                {t("USER_DETAIL:ON")}{" "}
                <strong>
                  {convertTimestamp(vehicleDetail.updated_at, true)}
                </strong>
              </p>
            </div>
          </div>

          <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
            <h3 className="font-roboto font-bold mb-[16px] text-lg">
              {t("VEHICLE_DETAIL:VEHICLE_SPESIFICATION")}
            </h3>
            <div className="flex flex-col gap-[24px]">
              <div className="flex">
                <div className="flex flex-col gap-[16px] w-1/4">
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_ID_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">{`${
                      vehicleDetail.vehicle_id ? vehicleDetail.vehicle_id : "-"
                    }`}</p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_TYPE_FIELD")}{" "}
                      <i>{t("VEHICLE_DETAIL:OPTION_TAG")}</i>
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">{`${
                      vehicleDetail.vehicle_type
                        ? vehicleDetail.vehicle_type
                        : "-"
                    }`}</p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_BRAND_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">{`${
                      vehicleDetail.vehicle_brand
                        ? vehicleDetail.vehicle_brand
                        : "-"
                    }`}</p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:LICENCE_PLATE_EXPIRED_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">{`${moment(
                      vehicleDetail.vehicle_no_exp_date,
                      "YYYY-MM-DD"
                    ).format("DD MMMM YYYY")}`}</p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_ENGINE_NUMBER_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">{`${
                      vehicleDetail.engine_no ? vehicleDetail.engine_no : "-"
                    }`}</p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_INSURANCE_NUMBER_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">{`${
                      vehicleDetail.insurance_no
                        ? vehicleDetail.insurance_no
                        : "-"
                    }`}</p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_INSURANCE_NUMBER_PHOTO_FIELD")}
                    </label>
                    <div className="border-[2px] border-[#999999] rounded-[5px] p-[18px] w-[149px] h-[149px] flex justify-center items-center">
                      {vehicleDetail.insurance_image &&
                      vehicleDetail.insurance_image !== "" ? (
                        <img
                          src={vehicleDetail.insurance_image}
                          alt="pict-vehicle-detail"
                        />
                      ) : (
                        <img src={NoImageLogo} alt="no-img-logos" />
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("Total Range Distance")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail?.total_range_distance
                        ? vehicleDetail?.total_range_distance
                        : 0}{" "}
                      Km
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-[16px] w-1/4">
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_OWNERSHIP_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.ownership == "Y"
                        ? "Owned"
                        : "Rent/Outsource"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:SKILL_SET_FIELD")}
                    </label>
                    <div className="flex flex-wrap gap-[4px] w-[321px]">
                      {vehicleDetail.skill_set.map((item) => (
                        <div className="px-[10px] py-[2px] bg-[#E7757A] rounded-[10px] w-fit text-white-100 font-roboto">
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_MODEL_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.vehicle_model
                        ? vehicleDetail.vehicle_model
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_WEIGHT_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.vehicle_weight
                        ? vehicleDetail.vehicle_weight
                        : "-"}{" "}
                      Kg
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MANUFACTURE_YEAR_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.manufacture_year
                        ? vehicleDetail.manufacture_year
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:ACCIDENT_HISTORY_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.accident_history
                        ? vehicleDetail.accident_history
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:LICENCE_PLATE_PHOTO_FIELD")}
                    </label>
                    <div className="border-[2px] border-[#999999] rounded-[5px] p-[18px] w-[149px] h-[149px] flex justify-center items-center">
                      {vehicleDetail.vehicle_no_image &&
                      vehicleDetail.vehicle_no_image !== "" ? (
                        <img src={vehicleDetail.vehicle_no_image} />
                      ) : (
                        <img src={NoImageLogo} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-[16px] w-1/4">
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_OWNER_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.owner_name
                        ? vehicleDetail.owner_name
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:TEMPERATURE_CATEGORY_ID_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.temperature_category
                        ? vehicleDetail.temperature_category
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:LICENCE_PLATE_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.vehicle_no
                        ? vehicleDetail.vehicle_no.replaceAll("-", " ")
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VEHICLE_CHASIS_NUMBER_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.chassis_no
                        ? vehicleDetail.chassis_no
                        : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:PUC_NUMBER_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.puc_no ? vehicleDetail.puc_no : "-"}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:PUC_NUMBER_PHOTO_FIELD")}
                    </label>
                    <div className="border-[2px] border-[#999999] rounded-[5px] p-[18px] w-[149px] h-[149px] flex justify-center items-center">
                      {vehicleDetail.puc_image &&
                      vehicleDetail.puc_image !== "" ? (
                        <img src={vehicleDetail.puc_image} />
                      ) : (
                        <img src={NoImageLogo} />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="font-roboto font-bold mb-[16px] text-lg">
                {"Vehicle Specification"}
              </h3>
              <div className="flex">
                <div className="flex flex-col gap-[16px] w-1/4">
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MIN_ORDER_UNIT_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.min_order_unit}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MAX_ORDER_WEIGHT_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.max_order_weight} Kg
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:FIX_COST_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      IDR {vehicleDetail.fixed_cost}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:WAITING_TIME_COST_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      IDR {vehicleDetail.waiting_time_cost}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-[16px] w-1/4">
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MAX_ORDER_UNIT_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.max_order_unit}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MIN_ORDER_VOLUME_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.min_order_volume} m³
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:VARIABLE_COST_PER_KM_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      IDR {vehicleDetail.variable_cost}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:LOADING_TIME_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.loading_time} Minutes
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-[16px] w-1/4">
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MIN_ORDER_WEIGHT_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.min_order_weight} Kg
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:MAX_ORDER_VOLUME_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      {vehicleDetail.max_order_volume} m³
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <label className="font-roboto text-[14px] text-[#818181]">
                      {t("VEHICLE_DETAIL:TRANSPORTER_TIME_COST_FIELD")}
                    </label>
                    <p className="font-[500] text-[20px] text-[#424242]">
                      IDR {vehicleDetail.transporter_time_cost}
                    </p>
                  </div>
                </div>
              </div>

              <h3 className="font-roboto font-bold text-lg">
                {"Additional Proofs"}
              </h3>
              <div className="flex flex-wrap">
                {vehicleDetail?.additional_proofs?.map((item, index) => {
                  if (index !== 3 && index % 3 === 0) {
                    return (
                      <div className="flex flex-col gap-[8px]">
                        <label className="font-roboto text-[14px] text-[#818181]">
                          {item?.additional_proofs_name}
                        </label>
                        <p className="font-[500] text-[20px] text-[#424242]">
                          {item?.value}
                        </p>
                      </div>
                    );
                  } else {
                    return (
                      <div className="flex flex-col gap-[8px] w-1/4">
                        <label className="font-roboto text-[14px] text-[#818181]">
                          {item.additional_proofs_name}
                        </label>
                        <p className="font-[500] text-[20px] text-[#424242]">
                          {item.value}
                        </p>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>

          <div className="flex flex-row-reverse gap-[16px]">
            <PrimaryButton
              action={() => toEdit()}
              text={t("VEHICLE_DETAIL:EDIT_BUTTON")}
            />
            <SecondaryButton
              text={t("VEHICLE_DETAIL:DELETE_BUTTON")}
              action={() =>
                deleteData(
                  vehicleDetail.vehicle_id,
                  vehicleDetail.updated_at,
                  vehicleDetail.vehicle_no,
                  vehicleDetail.vehicle_type
                )
              }
            />
          </div>

          <aside
            className={
              userManagementOpen
                ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
                : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
            }
          >
            <button
              className="absolute top-[21px] right-[21px]"
              onClick={() => setUserManagementOpen(false)}
            >
              <img src={CloseIcon} alt="" />
            </button>

            <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
              {t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}
            </h3>
            <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{vehicleDetail.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(vehicleDetail.created_at)}</strong>
            </p>

            <div className={style.timelineContainer}>
              <Timeline>
                {managementHistoryList.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                        <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                          <h4
                            className={"text-[#CF0000] font-[500] text-[14px]"}
                          >
                            {t("USER_DETAIL:LAST_MODIFIED")}
                          </h4>
                          <h4 className="font-[500] text-[14px] text-[#424242]">
                            {item.alias_name}
                          </h4>
                          <p className="font-[400] text-[14px]">{`${convertTimestamp(
                            item.created_at
                          )} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    );
                  } else {
                    return (
                      <Timeline.Item
                        dot={<img src={InactiveDotIcon} alt="icon-inactive" />}
                      >
                        <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                          <h4 className={"font-[500]"}>
                            {t("USER_DETAIL:MODIFIED")}
                          </h4>
                          <h4 className="font-[500] text-[14px] text-[#424242]">
                            {item.alias_name}
                          </h4>
                          <p className="font-[400] text-[14px]">{`${convertTimestamp(
                            item.created_at
                          )} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    );
                  }
                })}
              </Timeline>
            </div>
          </aside>
        </div>
      ) : null}
    </div>
  );
}
